import request from '@/utils/request'


// 查询任务订单列表
export function listTaskOrder(query) {
  return request({
    url: '/task/task/order/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询任务订单分页
export function pageTaskOrder(query) {
  return request({
    url: '/task/task/order/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询任务订单详细
export function getTaskOrder(data) {
  return request({
    url: '/task/task/order/detail',
    method: 'get',
    params: data
  })
}

// 新增任务订单
export function addTaskOrder(data) {
  return request({
    url: '/task/task/order/add',
    method: 'post',
    data: data
  })
}

// 修改任务订单
export function updateTaskOrder(data) {
  return request({
    url: '/task/task/order/edit',
    method: 'post',
    data: data
  })
}

// 删除任务订单
export function delTaskOrder(data) {
  return request({
    url: '/task/task/order/delete',
    method: 'post',
    data: data
  })
}

// 获取取消时间设置
export function getCancelTimeSetting() {
  return request({
    url: '/task/task/order/cancel-time/get',
    method: 'get'
  })
}

// 设置取消时间
export function setCancelTimeSetting(data) {
  return request({
    url: '/task/task/order/cancel-time/set',
    method: 'post',
    data: data
  })
}
